import { closest } from '../zzl-lib/domClosest'

window.addEventListener('click', (event) => {
	const button = closest('[data-dismiss]', event.target)
	if (!button) return

	const dismiss = button.getAttribute('data-dismiss')
	if (dismiss === '') return
	const target = closest(`.${dismiss}`, button)
	if (!target) return

	target.parentNode.removeChild(target)
})
